import {useState, useEffect} from 'react';
import api from '../api';


export const useDomain = ( { job, token }) => {
  const [domain, setDomain] = useState(null);
  useEffect(() => {
    console.log('Querying domain /info/job/fatty-acid-set')
    console.debug(job)
    if ((job.status === 'queued') || (job.status === 'pending')) {
      console.debug("returning early because job is not ready")
      return
    }
    const fetchFattyAcids = async () => {
      await api.get(
        '/info/job/fatty-acid-set', {
          params: {
            job_id: job.id,
          },
          headers: {
            authorization: token
          },
        }
      ).then(
        response => {
          setDomain(response.data.sort())
        }
       ).catch(
        error => {
          if (error.response.status === 408) {
            setDomain(null)
            return
          }
        }
      );
    }
    fetchFattyAcids();
  }, [job, token]);

  return domain
};


